import cn from "app/util/classnames";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "secondary" | "small" | "white";
  className?: string;
  doPing?: boolean;
  children: React.ReactNode;
}

export default function MenuButton({
  variant = "secondary",
  children,
  className,
  doPing = false,
  ...props
}: ButtonProps) {
  return (
    <button
      className={cn(
        "w-full max-w-40",
        "flex items-center justify-center",
        "rounded-sm px-1 py-2.5",
        "text-center",
        "relative isolate", // Required to contain the z-index layers properly
        "cursor-pointer",
        {
          "text-black disabled:opacity-20": variant === "white",
          "text-white hover:text-yellow disabled:opacity-20 font-medium text-lg uppercase":
            variant === "secondary",
          "text-sm font-condensed uppercase mix-blend-multiply text-black py-1 px-2 w-auto":
            variant === "small",
        },
        className,
      )}
      {...props}
    >
      <span className="relative z-20 pointer-events-none">{children}</span>

      <div
        className={cn("absolute inset-0 z-10 rounded-sm pointer-events-none", {
          "border border-white bg-white": variant === "white",
          "bg-black": variant === "secondary",
          "border border-black bg-transparent": variant === "small",
        })}
      />

      {doPing && (
        <div
          className={cn(
            "absolute inset-0 z-0 rounded-sm pointer-events-none",
            "bg-yellow-200",
            "animate-ping",
          )}
        />
      )}
    </button>
  );
}
